import React from "react";

const disclaimer =
  "This is a configuration page, the numbers displayed may not reflect the most up to date information. To see the accurate values for a specific testing date, visit the calculation preview page or download the calculation excel file.";

const configurationPageDisclaimer = () => (
  <div
    style={{
      color: "#5F6368",
      background: "rgba(255, 0, 0, 0.05)",
      border: "1px solid #DADCE0",
      borderRadius: "8px",
      padding: "1em"
    }}
  >
    <div>{disclaimer}</div>
  </div>
);

export default configurationPageDisclaimer;
